export const BRAND = {
  blue: "#0B5ED7",
  darkBlue: "#0A3E91",
  red: "#E11D48",
};